export const INITIATIVE_FIELDS = /* GraphQL */ `
  fragment InitiativeFields on Initiative {
    slug
    category
    title
    tagline
    description
    howItWorks
    iconName
    imageUrl
    confirmation
    interestedCount
    viewerStatus
    viewerFormData
    formFields {
      name
      label
      kind
      required
      placeholder
      helpText
      options {
        value
        label
      }
    }
  }
`;

export const INITIATIVES_Q = /* GraphQL */ `
  query Initiatives {
    initiatives {
      ...InitiativeFields
    }
  }
  ${INITIATIVE_FIELDS}
`;

export const SUGGEST_INITIATIVE_Q = /* GraphQL */ `
  query SuggestInitiative {
    suggestInitiative {
      ...InitiativeFields
    }
  }
  ${INITIATIVE_FIELDS}
`;

export const INITIATIVE_BY_SLUG_Q = /* GraphQL */ `
  query InitiativeBySlug($slug: String!) {
    initiative(slug: $slug) {
      ...InitiativeFields
    }
  }
  ${INITIATIVE_FIELDS}
`;

export const REGISTER_INITIATIVE_INTEREST_M = /* GraphQL */ `
  mutation RegisterInitiativeInterest($slug: String!, $formData: String) {
    registerInitiativeInterest(slug: $slug, formData: $formData)
  }
`;

export const DECLINE_INITIATIVE_M = /* GraphQL */ `
  mutation DeclineInitiative($slug: String!) {
    declineInitiative(slug: $slug)
  }
`;

export const WITHDRAW_INITIATIVE_INTEREST_M = /* GraphQL */ `
  mutation WithdrawInitiativeInterest($slug: String!) {
    withdrawInitiativeInterest(slug: $slug)
  }
`;

export const RESET_MY_INITIATIVES_M = /* GraphQL */ `
  mutation ResetMyInitiatives {
    resetMyInitiatives
  }
`;
